<template>
  <div class="page-faq">
    <main class="main">
      <breadcrumbs></breadcrumbs>

      <h1>Foire aux questions</h1>
      <!-- <a
        class="guide-link"
        :href="pdfLink"
        title="Télécharger le guide d'utilisation"
      >
        Guide d'utilisation
      </a> -->
      <faq-accordion
        v-if="questions.length"
        :items="questions"
      ></faq-accordion>
    </main>
  </div>
</template>

<script>
import Faq from '@/api/faq.js'
import FaqAccordion from '@/components/FaqAccordion'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  name: 'Faq',
  components: { FaqAccordion, Breadcrumbs },

  data () {
    return {
      questions: [],
      pdfLink: require('@/assets/files/doc.pdf')
    }
  },

  created () {
    Faq.list().then(response => {
      this.questions = response
    })
  }
}
</script>
